module.exports = __webpack_public_path__ + "img/pantalla-6-5.4d6bde0b.png";